// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2512e8e","453":"842a4c3a","732":"bd23938b","977":"364e4255"}[chunkId] + ".chunk.js";
};